export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.dashboard', {
            url: '/',
            component: 'dashboard',
            roles: []
        })
        .state('app.admin.revenueDashboard', {
            url: '/revenue-dashboard',
            component: 'revenueDashboard',
            resolve: {
                isGlobal: () => true,
                isRevenue: () => true,
            },
            roles: ['admin', 'investor']
        })
        .state('app.admin.statisticsDashboard', {
            url: '/statistics-dashboard',
            component: 'statisticsDashboard',
            resolve: {
                isGlobal: () => true,
                isStatistics: () => true,
            },
            roles: ['admin', 'investor']
        })
        .state('app.admin.bestSellersDashboard', {
            url: '/best-sellers',
            component: 'bestSellersDashboard',
            resolve: {
                isBestSellers: () => true
            }
        })
        .state('app.admin.premierDashboard', {
            url: '/premier-dashboard',
            component: 'premierDashboard',
            roles: ['admin', 'investor', 'premier_admin']
        })
        .state('app.admin.uploadContractCSV', {
            url: '/upload-contracts',
            component: 'uploadContracts',
            roles: ['admin']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/dashboard.routes.js